import { motion } from "framer-motion";

/* ─── STEP DATA (UNCHANGED) ───────────────────────────────────────── */
// const steps = [
//   {
//     id: "01",
//     title: "Choose Your Template",
//     description: "Explore and select a design that fits your brand from our curated collection.",
//     align: "right",
//     accent: "#e84c2b",
//     icon: (
//       <svg width="34" height="34" viewBox="0 0 34 34" fill="none">
//         <rect x="4" y="4" width="11" height="11" rx="2" stroke="#e84c2b" strokeWidth="2" />
//         <rect x="19" y="4" width="11" height="11" rx="2" stroke="#e84c2b" strokeWidth="2" />
//         <rect x="4" y="19" width="11" height="11" rx="2" stroke="#e84c2b" strokeWidth="2" />
//         <circle cx="24.5" cy="24.5" r="4" stroke="#e84c2b" strokeWidth="2" />
//         <line x1="27.3" y1="27.3" x2="30" y2="30" stroke="#e84c2b" strokeWidth="2" strokeLinecap="round" />
//       </svg>
//     ),
//   },
//   {
//     id: "02",
//     title: "Preview in Real-Time",
//     description: "Instantly visualize how your chosen template will look before moving forward.",
//     align: "left",
//     accent: "#1bcfb4",
//     icon: (
//       <svg width="34" height="34" viewBox="0 0 34 34" fill="none">
//         <circle cx="17" cy="17" r="4" stroke="#1bcfb4" strokeWidth="2.2" />
//         <circle cx="17" cy="17" r="9" stroke="#1bcfb4" strokeWidth="1.8" strokeDasharray="4 2.5" />
//         <circle cx="17" cy="17" r="14" stroke="#1bcfb4" strokeWidth="1.2" strokeDasharray="3 3" opacity="0.4" />
//       </svg>
//     ),
//   },
//   {
//     id: "03",
//     title: "Submit Your Details",
//     description: "Fill out a quick form to share your requirements and schedule a consultation.",
//     align: "right",
//     accent: "#e84c2b",
//     icon: (
//       <svg width="34" height="34" viewBox="0 0 34 34" fill="none">
//         <rect x="5" y="4" width="24" height="26" rx="3" stroke="#e84c2b" strokeWidth="2" />
//         <line x1="10" y1="11" x2="24" y2="11" stroke="#e84c2b" strokeWidth="2" strokeLinecap="round" />
//         <line x1="10" y1="17" x2="24" y2="17" stroke="#e84c2b" strokeWidth="2" strokeLinecap="round" />
//         <line x1="10" y1="23" x2="18" y2="23" stroke="#e84c2b" strokeWidth="2" strokeLinecap="round" />
//       </svg>
//     ),
//   },
//   {
//     id: "04",
//     title: "Requirement Analysis",
//     description: "We connect with you to understand your goals and tailor the solution accordingly.",
//     align: "left",
//     accent: "#1bcfb4",
//     icon: (
//       <svg width="34" height="34" viewBox="0 0 34 34" fill="none">
//         <circle cx="13" cy="11" r="4" stroke="#1bcfb4" strokeWidth="2" />
//         <path d="M5 28c0-4.4 3.6-8 8-8s8 3.6 8 8" stroke="#1bcfb4" strokeWidth="2" strokeLinecap="round" />
//         <circle cx="24" cy="13" r="3" stroke="#1bcfb4" strokeWidth="1.8" />
//         <path d="M22 23c2 .5 6 2.2 6 6" stroke="#1bcfb4" strokeWidth="1.8" strokeLinecap="round" />
//       </svg>
//     ),
//   },
//   {
//     id: "05",
//     title: "Fast Delivery",
//     description: "Get your fully customized product delivered within 24 hours.",
//     align: "right",
//     accent: "#e84c2b",
//     icon: (
//       <svg width="34" height="34" viewBox="0 0 34 34" fill="none">
//         <circle cx="17" cy="17" r="13" fill="#e84c2b" />
//         <polyline points="10,17 14.5,21.5 24,12" stroke="white" strokeWidth="2.8" strokeLinecap="round" strokeLinejoin="round" />
//       </svg>
//     ),
//   },
// ];



const steps = [
  {
    id: "01",
    title: "Choose Your  Website",
    description: "Explore and select a design that fits your brand from our curated collection.",
    align: "right",
    accent: "#e84c2b",
    icon: (
      <svg width="34" height="34" viewBox="0 0 34 34" fill="none">
        <rect x="4" y="4" width="11" height="11" rx="2" stroke="#e84c2b" strokeWidth="2" />
        <rect x="19" y="4" width="11" height="11" rx="2" stroke="#e84c2b" strokeWidth="2" />
        <rect x="4" y="19" width="11" height="11" rx="2" stroke="#e84c2b" strokeWidth="2" />
        <circle cx="24.5" cy="24.5" r="4" stroke="#e84c2b" strokeWidth="2" />
        <line x1="27.3" y1="27.3" x2="30" y2="30" stroke="#e84c2b" strokeWidth="2" strokeLinecap="round" />
      </svg>
    ),
  },
  // {
  //   id: "02",
  //   title: "Preview in Real-Time",
  //   description: "Instantly visualize how your chosen template will look before moving forward.",
  //   align: "left",
  //   accent: "#1bcfb4",
  //   icon: (
  //     <svg width="34" height="34" viewBox="0 0 34 34" fill="none">
  //       <circle cx="17" cy="17" r="4" stroke="#1bcfb4" strokeWidth="2.2" />
  //       <circle cx="17" cy="17" r="9" stroke="#1bcfb4" strokeWidth="1.8" strokeDasharray="4 2.5" />
  //       <circle cx="17" cy="17" r="14" stroke="#1bcfb4" strokeWidth="1.2" strokeDasharray="3 3" opacity="0.4" />
  //     </svg>
  //   ),
  // },
  {
    id: "02",
    title: "Submit Your Details",
    description: "Fill out a quick form to share your requirements and schedule a consultation.",
    align: "left",
    accent: "#1bcfb4",
    icon: (
      <svg width="34" height="34" viewBox="0 0 34 34" fill="none">
        <circle cx="17" cy="17" r="4" stroke="#1bcfb4" strokeWidth="2.2" />
        <circle cx="17" cy="17" r="9" stroke="#1bcfb4" strokeWidth="1.8" strokeDasharray="4 2.5" />
        <circle cx="17" cy="17" r="14" stroke="#1bcfb4" strokeWidth="1.2" strokeDasharray="3 3" opacity="0.4" />
      </svg>
    ),
  },


    {
    id: "03",
    title: "Requirement Analysis",
    description: "We connect with you to understand your goals and tailor the solution accordingly.",
    align: "right",
    accent: "#e84c2b",
    icon: (
      <svg width="34" height="34" viewBox="0 0 34 34" fill="none">
        <circle cx="13" cy="11" r="4" stroke="#1bcfb4" strokeWidth="2" />
        <path d="M5 28c0-4.4 3.6-8 8-8s8 3.6 8 8" stroke="#1bcfb4" strokeWidth="2" strokeLinecap="round" />
        <circle cx="24" cy="13" r="3" stroke="#1bcfb4" strokeWidth="1.8" />
        <path d="M22 23c2 .5 6 2.2 6 6" stroke="#1bcfb4" strokeWidth="1.8" strokeLinecap="round" />
      </svg>
    ),
  },

  
  {
    id: "04",
    title: "Upload Your Products",
    description: "After Completing the entire setup process, you can seamlessly upload and manage your products on the platform with ease.",
    align: "left",
    accent: "#1bcfb4",
    icon: (
      <svg width="34" height="34" viewBox="0 0 34 34" fill="none">
        <rect x="5" y="4" width="24" height="26" rx="3" stroke="#e84c2b" strokeWidth="2" />
        <line x1="10" y1="11" x2="24" y2="11" stroke="#e84c2b" strokeWidth="2" strokeLinecap="round" />
        <line x1="10" y1="17" x2="24" y2="17" stroke="#e84c2b" strokeWidth="2" strokeLinecap="round" />
        <line x1="10" y1="23" x2="18" y2="23" stroke="#e84c2b" strokeWidth="2" strokeLinecap="round" />
      </svg>
    ),
  },

  //  {
  //   id: "03",
  //   title: "Upload Your Products",
  //   description: "After Completing the entire setup process, you can seamlessly upload and manage your products on the platform with ease.",
  //   align: "left",
  //   accent: "#e84c2b",
  //   icon: (
  //     <svg width="34" height="34" viewBox="0 0 34 34" fill="none">
  //       <rect x="5" y="4" width="24" height="26" rx="3" stroke="#e84c2b" strokeWidth="2" />
  //       <line x1="10" y1="11" x2="24" y2="11" stroke="#e84c2b" strokeWidth="2" strokeLinecap="round" />
  //       <line x1="10" y1="17" x2="24" y2="17" stroke="#e84c2b" strokeWidth="2" strokeLinecap="round" />
  //       <line x1="10" y1="23" x2="18" y2="23" stroke="#e84c2b" strokeWidth="2" strokeLinecap="round" />
  //     </svg>
  //   ),
  // },


  // {
  //   id: "04",
  //   title: "Requirement Analysis",
  //   description: "We connect with you to understand your goals and tailor the solution accordingly.",
  //   align: "left",
  //   accent: "#1bcfb4",
  //   icon: (
  //     <svg width="34" height="34" viewBox="0 0 34 34" fill="none">
  //       <circle cx="13" cy="11" r="4" stroke="#1bcfb4" strokeWidth="2" />
  //       <path d="M5 28c0-4.4 3.6-8 8-8s8 3.6 8 8" stroke="#1bcfb4" strokeWidth="2" strokeLinecap="round" />
  //       <circle cx="24" cy="13" r="3" stroke="#1bcfb4" strokeWidth="1.8" />
  //       <path d="M22 23c2 .5 6 2.2 6 6" stroke="#1bcfb4" strokeWidth="1.8" strokeLinecap="round" />
  //     </svg>
  //   ),
  // },

   {
    id: "05",
    title: "Get It Live",
    description: "Once the website development process is completed, we will deploy and launch your website live for users worldwide.",
    align: "right",
    accent: "#e84c2b",
    icon: (
      <svg width="34" height="34" viewBox="0 0 34 34" fill="none">
        <circle cx="13" cy="11" r="4" stroke="#1bcfb4" strokeWidth="2" />
        <path d="M5 28c0-4.4 3.6-8 8-8s8 3.6 8 8" stroke="#1bcfb4" strokeWidth="2" strokeLinecap="round" />
        <circle cx="24" cy="13" r="3" stroke="#1bcfb4" strokeWidth="1.8" />
        <path d="M22 23c2 .5 6 2.2 6 6" stroke="#1bcfb4" strokeWidth="1.8" strokeLinecap="round" />
      </svg>
    ),
  },
  // {
  //   id: "06",
  //   title: "Fast Delivery",
  //   description: "Get your fully customized product delivered within 24 Working hours.",
  //   align: "left",
  //   accent: "#1bcfb4",
  //   icon: (
  //     <svg width="34" height="34" viewBox="0 0 34 34" fill="none">
  //       <circle cx="17" cy="17" r="13" fill="#e84c2b" />
  //       <polyline points="10,17 14.5,21.5 24,12" stroke="white" strokeWidth="2.8" strokeLinecap="round" strokeLinejoin="round" />
  //     </svg>
  //   ),
  // },
];


/* ─── DOTS (Smoother Opacity) ─────────────────────────────────── */
const Dots = () => (
  <div className="dots-container">
    {[0, 1, 2, 3, 4].map((i) => (
      <motion.span
        key={i}
        className="dot-item"
        animate={{ opacity: [0.2, 1, 0.2], scale: [1, 1.2, 1] }}
        transition={{ duration: 2.5, repeat: Infinity, delay: i * 0.15, ease: "easeInOut" }}
      />
    ))}
  </div>
);

/* ─── BADGE (Smooth Hover) ─────────────────────────────────────── */
const Badge = ({ id, color }) => (
  <motion.div
    className="step-badge"
    style={{ borderColor: color, color: color }}
    whileHover={{ scale: 1.15, rotate: 8, boxShadow: `0 0 15px ${color}60` }}
    transition={{ type: "spring", stiffness: 300 }}
  >
    {id}
  </motion.div>
);

/* ─── CARD (Refined Hover) ─────────────────────────────────────── */
const Card = ({ step, isRight }) => {
  return (
    <motion.div
      className={`step-card ${isRight ? "card-right" : "card-left"}`}
      whileHover={{ y: -5, scale: 1.01 }}
      transition={{ type: "spring", stiffness: 200, damping: 15 }}
    >
      <div
        className="card-content"
        style={{
          backgroundImage: isRight
            ? `url('/assets/images/union.webp')`
            : `url('/assets/images/unionto.webp')`,
        }}
      >
        <motion.div
          className="icon-wrapper"
          style={{ boxShadow: `0 0 32px ${step.accent}30` }}
          animate={{ y: [0, -6, 0], rotate: [0, 2, -2, 0] }}
          transition={{ duration: 5, repeat: Infinity, ease: "easeInOut" }}
        >
          {step.icon}
        </motion.div>

        <div className="text-wrapper">
          <h3 className="card-title">{step.title}</h3>
          <p className="card-desc    m-0">{step.description}</p>
        </div>
      </div>
    </motion.div>
  );
};

/* ─── IMPROVED VARIANTS ────────────────────────────────────────── */
const rowVariants = {
  hidden: (isRight) => ({
    opacity: 0,
    x: isRight ? 80 : -80,
    filter: "blur(4px)",
  }),
  visible: {
    opacity: 1,
    x: 0,
    filter: "blur(0px)",
    transition: {
      type: "spring",
      stiffness: 60,
      damping: 15,
      mass: 0.8,
    },
  },
};

const containerVariants = {
  hidden: { opacity: 0 },
  visible: {
    opacity: 1,
    transition: {
      staggerChildren: 0.25,
      delayChildren: 0.1,
    },
  },
};

/* ─── STEP ROW ─────────────────────────────────────────────────── */
const StepRow = ({ step }) => {
  const isRight = step.align === "right";

  return (
    <motion.div
      className={`step-row ${isRight ? "row-right" : "row-left"}  custom-red-section`}
      variants={rowVariants}
      custom={isRight}
    >
      <div className="meta-group">
        {isRight ? (
          <>
            <Badge id={step.id} color={step.accent} />
            <Dots />
          </>
        ) : (
          <>
            <Dots />
            <Badge id={step.id} color={step.accent} />
          </>
        )}
      </div>
      <Card step={step} isRight={isRight} />
    </motion.div>
  );
};

/* ─── MAIN ─────────────────────────────────────────────────────── */
export default function ProcessSteps() {
  return (
    <>
      <style>{`
      
      
      `}</style>

      <div className="ax-process-title-container">
        <motion.div
          initial={{ opacity: 0, scale: 0.9 }}
          whileInView={{ opacity: 1, scale: 1 }}
          transition={{ duration: 2, ease: "easeOut" }}
          viewport={{ once: false }}
          className="ax-process-title-wrapper"
        >
          <h2 className="ax-process-main-text">
            <span className="ax-font-arcade">WHAT</span>
            <span className="ax-font-kalam">is the</span>
            {/* <span className="ax-font-process">process?</span> */}
            {/* <span className="ax-font-process"> */}
              <span className="   ax-font-process  ax-process-rotate-p">Process?</span>
            {/* </span> */}
          </h2>
          <div className="ax-custom-logo-sec-divider    pt-3">
            <div className="ax-custom-logo-sec-line"></div>
            <span className="ax-custom-logo-sec-star">★</span>
            <div className="ax-custom-logo-sec-line"></div>
          </div>
        </motion.div>
      </div>

      <section className="process-section">
        <motion.div
          className="process-inner"
          variants={containerVariants}
          initial="hidden"
          whileInView="visible"
          viewport={{ once: false, margin: "-100px" }}
        >
          {steps.map((step, i) => (
            <StepRow key={i} step={step} />
          ))}
        </motion.div>
      </section>
    </>
  );
}